import React from 'react';
import UserTable from './components/UserTable';

const App: React.FC = () => {
  return (
    <div className="App">
      <UserTable />
    </div>
  );
};

export default App;

export {};